export const viteConfig = {
  VITE_BENEFITS_EXPLORER_BASE_URL: import.meta.env.VITE_BENEFITS_EXPLORER_BASE_URL,
} as const;
